<template>
    <svg width="23"
         height="22"
         viewBox="0 0 23 22"
         fill="none"
         xmlns="http://www.w3.org/2000/svg">
        <rect x="0.800049"
              width="22"
              height="22"
              rx="11"
              fill="#858E97"/>
        <g clip-path="url(#clip0_10985_26947)">
            <circle cx="7.80005"
                    cy="11"
                    r="1"
                    fill="white"/>
            <circle cx="11.8"
                    cy="11"
                    r="1"
                    fill="white"/>
            <circle cx="15.8"
                    cy="11"
                    r="1"
                    fill="white"/>
        </g>
        <defs>
            <clipPath id="clip0_10985_26947">
                <rect width="10"
                      height="10"
                      fill="white"
                      transform="translate(6.80005 6)"/>
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    name: 'IconProcess'
};
</script>
